import type { TFunction } from 'i18next';
import type { CognitiveFitness } from '../../model';
import type { AssessmentResultItemDataFragment } from '@/gql/graphql';
import { formatDecimalValue } from '@/utils/common';

const parseSart = (t: TFunction, items: AssessmentResultItemDataFragment[]): CognitiveFitness | null => {
    const item = items.find(i => i.result.__typename === 'SartResult');
    if (!item || item.result.__typename !== 'SartResult') {
        return null;
    }
    const mi = item.moduleInstance;
    const r = item.result;
    if (!mi?.name) {
        return null;
    }

    const correctHits = Number(r.correctHits ?? 0);
    const incorrectPresses = Number(r.incorrectPresses ?? 0);
    const denom = correctHits + incorrectPresses;
    const score = denom > 0 ? (correctHits / denom) * 100 : null;
    const scoreDisplay =
        score != null && Number.isFinite(score)
            ? t('traineeReports:performance.cognitiveFitness.scoreValue', { value: `${formatDecimalValue(score)}/100` })
            : t('traineeReports:na');

    return {
        name: mi.name ?? '',
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.scoreLabel'),
                value: scoreDisplay,
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.avgResponseTimeMs'),
                value: `${Math.round(r.averageResponseTimeMs)}`,
            },
        ],
    };
};

export default parseSart;
